var passiveSupported = false;
if (typeof window !== 'undefined') {
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                passiveSupported = true;
                return true;
            },
        });
        // @ts-ignore
        window.addEventListener('test', options, options);
        // @ts-ignore
        window.removeEventListener('test', options, options);
    }
    catch (err) {
        passiveSupported = false;
    }
}
export var nonPassive = passiveSupported ? { passive: false } : false;



//////////////////
// WEBPACK FOOTER
// ./~/react-remove-scroll/dist/es2015/aggresiveCapture.js
// module id = 9048
// module chunks = 2